var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoZapier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4327 25.4428C22.5832 26.5151 19.3902 26.5171 16.5406 25.4435C15.467 22.5971 15.4668 19.4047 16.539 16.5579C19.3878 15.4838 22.584 15.4836 25.4328 16.5577C26.506 19.4037 26.5056 22.5968 25.4327 25.4428ZM41.708 17.5001H29.442L38.1149 8.83217C36.7538 6.92139 35.0734 5.24288 33.1614 3.88256L24.4879 12.5505V0.292383C22.173 -0.0967808 19.799 -0.0961879 17.4841 0.292383V12.5505L8.81057 3.88256C6.89908 5.24196 5.21816 6.92277 3.85693 8.83217L12.5311 17.5001H0.265246C-0.0375277 19.8828 -0.135899 22.1221 0.265246 24.5H12.5313L3.8571 33.1679C5.22161 35.0815 6.8957 36.7545 8.81057 38.1181L17.4841 29.4496V41.7083C19.7992 42.096 22.1726 42.0963 24.4877 41.7083V29.4496L33.1621 38.1181C35.0749 36.7565 36.7523 35.0794 38.1149 33.1679L29.4407 24.5H41.708C42.0973 22.1886 42.0973 19.8115 41.708 17.5001Z",
    fill: "#FF4A00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoZapier);
export default __webpack_public_path__ + "static/media/logo-zapier.fcb35dc6.svg";
export { ForwardRef as ReactComponent };